import { render, staticRenderFns } from "./event-component.vue?vue&type=template&id=aace44cc&scoped=true"
import script from "./event-component.vue?vue&type=script&lang=js"
export * from "./event-component.vue?vue&type=script&lang=js"
import style0 from "./event-component.vue?vue&type=style&index=0&id=aace44cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aace44cc",
  null
  
)

export default component.exports